import { ArrowLeft } from "@gravity-ui/icons";
import { Button, Flex, Icon, Text } from "@gravity-ui/uikit";
import {
  ProductDetailResponseDto,
  ProductSourceDtoSourceEnum,
} from "definitions/product-storage";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { useTranslate } from "src/i18n";

import { BLUR_PRICE, BLUR_VARIANTS } from "../../ProductDetailPage.constant";
import { ProductImage, ProductModalBody } from "./components";
import { useProductVariantsController } from "./hooks";
import css from "./ProductModalContent.module.scss";

export const ProductModalContent = ({
  product,
  hasSubscribe,
}: {
  product: ProductDetailResponseDto;
  hasSubscribe?: boolean;
}) => {
  const { t } = useTranslate();
  const [platform, setPlatform] = useState<ProductSourceDtoSourceEnum | null>(
    null,
  );
  const { isDesktop } = useGravityDevice();
  const navigate = useNavigate();

  const id = platform
    ? product.productSources?.find((p) => p.source === platform)?.externalId
    : null;

  const { variants, isLoading, selected, setSelected, activeVariant, reload } =
    useProductVariantsController(id, platform);

  const priceProps = useMemo(
    () => ({
      isLoading,
      isBlur: !platform,
      showSelectPlatformPrompt: !platform,
      variants: !platform ? BLUR_VARIANTS : variants,
      selected,
      onChange: setSelected,
      activeVariant: !platform ? null : activeVariant,
      blurPrice: !platform ? BLUR_PRICE : null,
    }),
    [isLoading, platform, variants, selected, setSelected, activeVariant],
  );

  return (
    <Flex direction="column" gap="3">
      <Button
        view="flat"
        size="m"
        style={{ fontWeight: "bold", marginRight: "auto" }}
        onClick={() => navigate(-1)}
      >
        <Icon data={ArrowLeft} />
        {t("back", "Назад")}
      </Button>
      <Flex className={css.contentMargin} gap="10">
        <ProductImage
          images={product.productImages}
          size={isDesktop ? 400 : 350}
        />
        <Flex direction="column" gap="3" className={css.contentWidth}>
          <Text variant="subheader-3">{product.title}</Text>
          <ProductModalBody
            product={product}
            platform={platform}
            setPlatform={setPlatform}
            hasSubscribe={hasSubscribe}
            reload={reload}
            priceProps={priceProps}
            isDesktop={isDesktop}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};
